<p>thrift-announce-modal works!</p>
